import React, { useMemo } from 'react';
import { Button, Typography, useGlobalContext } from 'seagull';
import BillServiceModal from "../../BillServiceModal/BillServiceModal";
import styles from "../ServicesSection.module.scss";
import { billableStateModel } from "../../../../../models";
import { Intent } from "../../../../../infra/access-control";
const nonBillableReasonToTooltip = {
  issuingInvoice: 'An invoice is being issued. Please wait',
  billedMaxCharges: 'This service was already billed the maximum number of times'
};
export default function ManualServiceBillingItem(props) {
  const {
    name,
    costDisplay,
    unitCapDisplay,
    service,
    idx,
    agreement,
    invoiceDateInfo,
    manualServiceBilling,
    totalCredits,
    onRefresh
  } = props;
  const globalContext = useGlobalContext();
  const nonBillableReason = useMemo(() => {
    const {
      billableState
    } = manualServiceBilling || {};
    return billableState ? billableStateModel.nonBillableReason(billableState) : null;
  }, [manualServiceBilling]);
  return /*#__PURE__*/React.createElement("li", {
    "data-testid": "service-".concat(idx),
    className: styles.serviceBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.serviceDescription
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "name"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: styles.cost
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "cost",
    variant: "paragraph2",
    skin: "secondary"
  }, costDisplay), unitCapDisplay && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "unit-cap",
    variant: "paragraph2",
    skin: "secondary"
  }, unitCapDisplay))), /*#__PURE__*/React.createElement("div", {
    className: styles.lineItemAction
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    intent: Intent.Bill,
    "data-testid": "billing-control-manual-bill-".concat(service === null || service === void 0 ? void 0 : service.id),
    "data-reason": nonBillableReason || '',
    disabled: nonBillableReason != null,
    tooltip: nonBillableReason != null ? {
      placement: 'top',
      title: nonBillableReasonToTooltip[nonBillableReason]
    } : undefined,
    onClick: () => {
      globalContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref => {
          let {
            dismissModal
          } = _ref;
          return /*#__PURE__*/React.createElement(BillServiceModal, {
            serviceWithAmendments: service,
            invoiceDateInfo: invoiceDateInfo,
            relationship: agreement,
            dismissModal: dismissModal,
            manualServiceBilling: manualServiceBilling,
            totalCredits: totalCredits,
            onRefresh: onRefresh
          });
        }
      });
    }
  }, "Bill")));
}